import fetcher from '../modules/ajio-fetch';
import { GET_ASSURED_GIFTS_DATA_SUCCESS } from '../constants/assuredGiftsConstants';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  tokenReCreateParser
} from '../modules/ajio-fetch/utils';
import { getAssuredGift } from '../refresh/pages/AssuredGiftsPage/assuredGiftsAPI';

function getEventInfoApiSuccess(data) {
  return {
    type: GET_ASSURED_GIFTS_DATA_SUCCESS,
    data
  };
}

export function assuredGiftsAPI(isRequestOrginIsBrowser, request, orderValue) {
  if (isRequestOrginIsBrowser) {
    const apiEndpoint = `/api/games/fetchAssuredGifts?orderValue=${orderValue}`;
    return fetcher(
      apiEndpoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: {
          Accept: 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        }
      })
    ).then(fetchGetJSONResHandler);
  }
  return getAssuredGift(request);
}

export function fetchAssuredGift(
  requestObj = {},
  callback,
  isRecursivelyCalling = false,
  orderValue
) {
  const { isRequestOrginIsBrowser = true, request = {} } = requestObj;
  return dispatch => {
    return assuredGiftsAPI(isRequestOrginIsBrowser, request, orderValue)
      .then(response => {
        dispatch(getEventInfoApiSuccess(response));
        if (callback) {
          callback(response);
        }
        return Promise.resolve(response);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        if (statusCode === 504) {
          statusCode = 400;
        }
        return errorParser(error, statusCode).then((errorObj = {}) => {
          const { reason = '' } = errorObj;
          if (statusCode === 401 && !isRecursivelyCalling) {
            return tokenReCreateParser(statusCode, errorObj, requestObj.request)
              .then(resp => {
                if (!isRequestOrginIsBrowser) {
                  requestObj.request.cookies.A = resp.access_token;
                }
                return Promise.resolve(fetchAssuredGift(requestObj, callback, true)(dispatch));
              })
              .catch(err => {
                return Promise.reject(err);
              });
          }
          return Promise.reject(errorObj);
        });
      });
  };
}
